





































import { Component, Vue, Watch } from "vue-property-decorator";
import { Material, materialsStore } from "@/utils/material";
import MaterialForm from "@/components/MaterialForm.vue";

@Component({ components: { MaterialForm } })
export default class Materials extends Vue {
  materials: Record<string, Material> = materialsStore.get().reduce(
    (acc, ea) => ({
      ...acc,
      [ea.name]: ea,
    }),
    {}
  );

  updateMaterial(name: string): (material: Material) => void {
    return (material: Material) => {
      if (material.name !== name) {
        delete this.materials[name];
      }
      this.materials = { ...this.materials, [material.name]: material };
    };
  }

  deleteMaterial(name: string): () => void {
    return () => {
      delete this.materials[name];
      this.materials = { ...this.materials };
    };
  }

  @Watch("materials", { deep: true })
  materialsUpdated(): void {
    materialsStore.set(Object.values(this.materials));
  }

  addNewMaterial() {
    this.materials = {
      ...this.materials,
      "New Material": { name: "New Material", kFactor: 10 },
    };
  }
}
